module.exports = __webpack_public_path__ + "static/media/home-play.e865ecd4.svg";